import React, { useState } from 'react';
import { routes } from '../../routes/routes';
import {
  NavContainer,
  NavLink,
  DropdownContainer,
  DropdownMenu,
  DropdownItem,
} from './NavDesktop.styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { Logo } from './Logo';
import { useTranslation } from 'react-i18next';

export const NavDesktop = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    // Najpierw przejdź do strony wypraw jeśli nie jesteśmy na niej
    if (location.pathname !== '/projects/hiking') {
      navigate('/projects/hiking');
      // Poczekaj na załadowanie strony przed scrollowaniem
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // Jeśli już jesteśmy na stronie, scrolluj od razu
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    setIsDropdownOpen(false);
  };

  return (
    <NavContainer>
      {!isHomePage && <Logo />}
      {routes
        .filter((route) => route.showInNav)
        .map(({ href, title }) => {
          const isActive = location.pathname === href;

          // Specjalne traktowanie dla zakładki "Wyprawy"
          if (title === 'nav.hiking') {
            return (
              <DropdownContainer
                key={title}
                onMouseEnter={() => setIsDropdownOpen(true)}
                onMouseLeave={() => setIsDropdownOpen(false)}
              >
                <p>
                  <NavLink to={href} isActive={isActive}>
                    {t(title)}
                  </NavLink>
                </p>
                {isDropdownOpen && (
                  <DropdownMenu>
                    <DropdownItem onClick={() => scrollToSection('wyjazdy-2026')}>
                      {t('nav.year2026')}
                    </DropdownItem>
                    <DropdownItem onClick={() => scrollToSection('archiwalne')}>
                      {t('nav.archived')}
                    </DropdownItem>
                  </DropdownMenu>
                )}
              </DropdownContainer>
            );
          }

          return (
            <p key={title}>
              <NavLink to={href} isActive={isActive}>
                {t(title)}
              </NavLink>
            </p>
          );
        })}
    </NavContainer>
  );
};
